import Vue from 'vue'
import App from './App.vue'
import VueTimers from 'vue-timers';
import JQuery from 'jquery';
import Bootstrap from 'bootstrap';
import BootstrapVue from 'bootstrap-vue';

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(fas);
library.add(far);
library.add(fab);

import _ from 'lodash';

import VueIziToast from 'vue-izitoast';
import 'izitoast/dist/css/iziToast.css';

Vue.use(VueIziToast);


window.$ = require('jquery');
window.JQuery = require('jquery');

// Require Froala Editor js file.
require('froala-editor/js/froala_editor.pkgd.min');

// Require Froala Editor css files.
require('froala-editor/css/froala_editor.pkgd.min.css');
require('font-awesome/css/font-awesome.css');
require('froala-editor/css/froala_style.min.css');

// Import and use Vue Froala lib.
import VueFroala from 'vue-froala-wysiwyg'
Vue.use(VueFroala);

import router from './router'
import store from './store/index'


Vue.use(VueTimers);
Vue.use(BootstrapVue);
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(VueIziToast);

import ToggleButton from 'vue-js-toggle-button'
Vue.use(ToggleButton);

import VueSweetalert2 from 'vue-sweetalert2';
Vue.use(VueSweetalert2);

import vSelect from 'vue-select'
Vue.component('v-select', vSelect)

Vue.config.productionTip = false


// Style Sheets
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

// Main Style
require('./assets/css/style.scss');

// Load instance Variables (config)
switch (process.env.VUE_APP_INSTANCE) {
    case 'pspnet':
        require('./instance.pspnet.js');
        break;
    case 'otu':
        require('./instance.otu.js');
        break;
    default:
        require('./instance.otu.js');
        break;
}

// Locales
import i18n from './i18n';

new Vue({ i18n, router, store, render: function (h) { return h(App) } }).$mount('#app');
